import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { reviewObj } from 'src/app/interfaces/product';
import { ModalOpenFullimageComponent } from '../modal-open-fullimage/modal-open-fullimage.component';
import { CapacitorVideoPlayer } from 'capacitor-video-player';
import { ModalCustomAlertComponent } from '../modal-custom-alert/modal-custom-alert.component';

@Component({
  selector: 'app-product-review-item',
  templateUrl: './product-review-item.component.html',
  styleUrls: ['./product-review-item.component.scss'],
})
export class ProductReviewItemComponent implements OnInit {
  @Input() review: reviewObj;
  unkownName: string;

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.unkownName = this.generateRandomName(5, 8);
  }

  generateRandomName(minLength: number, maxLength: number) {
    const getRandomAlphabet = () => String.fromCharCode(Math.floor(Math.random() * 26) + 65);

    const length = Math.floor(Math.random() * (maxLength - minLength) + minLength);
    const firstLetter = getRandomAlphabet();
    const lastLetter = getRandomAlphabet();
    const middlePart = '*'.repeat(Math.max(0, length - 2));

    return firstLetter + middlePart + lastLetter;
  }

  async openFullImage(image: string) {
    const isMobile = window.innerWidth <= 576;

    const mobileMmodal = await this.modalController.create({
      component: ModalOpenFullimageComponent,
      cssClass: 'modal-bottom',
      componentProps: {
        imgAlert: image,
        useCloseBtn: false,
      },
    });

    const desktopModal = await this.modalController.create({
      component: ModalCustomAlertComponent,
      cssClass: 'modal-bottom modal-fullscreen',
      componentProps: {
        imgAlert: image,
        useCloseBtn: true,
      },
    });

    if (isMobile) {
      mobileMmodal.present();

      const { data, role } = await mobileMmodal.onDidDismiss();

      if (role === 'cancel') {
        return;
      }
    } else {
      desktopModal.present();

      const { data, role } = await desktopModal.onDidDismiss();

      if (role === 'cancel') {
        return;
      }
    }
  }

  async playRecording(url: string) {
    await CapacitorVideoPlayer.initPlayer({
      mode: 'fullscreen',
      url,
      playerId: 'fullscreen',
      componentTag: 'app-product-rating',
      pipEnabled: false,
    });
  }
}
